import { Flex, FlexProps, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

export const WarningBar = (props: FlexProps) => {
  const { t } = useTranslation('common')

  return (
    <Flex
      h={{ sm: '40px' }}
      alignItems="center"
      justifyContent={{ base: 'center', sm: 'flex-start' }}
      bg="state.warning"
      {...props}
    >
      <Text color="brand.white" p={{ base: '10px', sm: 0 }} ml={{ sm: '35px' }}>
        {t('BRAND_PROFILE_ACTIVE_PLAN_DESC')}
      </Text>
    </Flex>
  )
}
